import React, { useContext } from 'react';
import Header from '../components/Layout/Header';
import { LanguageContext } from '../context/LanguageContext';
import ExpandingCardsDesign from '../components/Vibhag/designs/ExpandingCardsDesign';
import './HomePage.css';
import './VibhagPage.css';
import ScrollAnimation from '../components/ScrollAnimations';

const translations = {
  en: {
    'nav-home': 'Home',
    'nav-about': 'About',
    'nav-mission': 'Mission',
    'nav-activities': 'Activities & Events',
    'nav-projects': 'Gurupeeth Projects',
    'nav-vibhag': '18 Vibhag',
    'nav-wisdom': 'Wisdom',
    'nav-contact': 'Contact',
    'nav-donate': 'Donate',
    header: "Dindori Pranit - 18 Vibhag",
    breadcrumb: "Home / Dindori Pranit - 18 Vibhag",
    title: "Dindori Pranit - 18 Vibhag",
    detailedDescription: "After studying various problems in society, the respected Gurumauli Annasaheb More started the Gram Abhiyan for service workers. For the past four decades, the respected Gurumauli has been continuously and successfully carrying out this work. Based on the principle of '20% spirituality and 80% social work', this service path is tirelessly working for society. Through 18 vibhags in the service path, various programs are implemented under the Gram and Urban Development Campaign."
  },
  mr: {
    'nav-home': 'मुख्यपृष्ठ',
    'nav-about': 'आमच्याबद्दल',
    'nav-mission': 'ध्येय',
    'nav-activities': 'कार्यक्रम व इव्हेंट्स',
    'nav-projects': 'प्रकल्प',
    'nav-vibhag': '१८ विभाग',
    'nav-wisdom': 'ज्ञान',
    'nav-contact': 'संपर्क',
    'nav-donate': 'देणगी',
    header: "१८ विभाग",
    breadcrumb: "मुख्यपृष्ठ / १८ विभाग",
    title: "१८ विभाग",
    detailedDescription: "समाजातील अनेक समस्यांचा अभ्यास करून परमपूज्य गुरुमाऊली अण्णासाहेब मोरे यांनी सेवेकऱ्यांचे ग्राम अभियान सुरू केले. गेल्या चार दशकांपासून परमपूज्य गुरुमाऊली हे कार्य निरंतर आणि यशस्वीपणे चालवत आहेत. \"20 टक्के अध्यात्म आणि 80 टक्के समाजकार्य\" या सूत्रांवर आधारित हा सेवा मार्ग अव्याहतपणे समाजासाठी झटत आहे. सेवा मार्गातील 18 विभागांमधून ग्राम व नागरी विकास अभियान अंतर्गत विविध उपक्रम राबवले जातात."
  }
};

const VibhagPage = () => {
  const { lang, setLang } = useContext(LanguageContext);
  
  const t = (key) => {
    // Return the translated string, or a default for safety
    return translations[lang][key] || translations['en'][key];
  };

  return (
    <div className="vibhag-page">
      <Header />

      <main className="vibhag-main">
        {/* Hero Section */}
        <section className="vibhag-hero">
          <div className="wrap">
            <ScrollAnimation animation="fade-down" delay={100}> 
              <h2 className="page-title">{t('title')}</h2>
            </ScrollAnimation>

            {/* Detailed Description Blockquote */}
            <ScrollAnimation animation="fade-up" delay={300}>
            <blockquote className="vibhag-blockquote">
              <p>{t('detailedDescription')}</p>
            </blockquote>
            </ScrollAnimation>
          </div>
        </section>

        {/* Departments Section */}
        <section className="vibhag-content">
          <div className="wrap">
            <ExpandingCardsDesign />
          </div>
        </section>
      </main>
    </div>
  );
};

export default VibhagPage;
